function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDkUlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1355.9797mm",
    height: "186.67918mm",
    viewBox: "0 0 1355.9797 186.67918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v71.26C-72.545 34.554-116.661 3.885-112.355-8.567-108.479-19.761-65.625-15.584 0 0m631.78 255.505c7.007-19.234-52.657-62.586-151.493-111.75V-9.536c0-47.68-40.093-56.461-70.432-56.461-30.691 0-70.626 8.695-70.626 55.934V80.98a2480 2480 0 0 0-42.308-16.51l24.732-128.336h-62.494l-17.15 108.252c-2.428-.862-4.867-1.717-7.292-2.573V-63.866h-60.63v85.457a2128 2128 0 0 0-34.698-10.764V-7.599c0-58.636-51.731-56.494-51.731-56.494H0v38.951c-84.112-17.361-139.766-18.931-145.811-2.336C-152.668-8.654-95.356 32.616 0 79.95v215.809h87.277s52.112 1.506 52.112-54.472V51.237a3020 3020 0 0 0-61.027-19.675v205.189c0 17.333-5.815 17.333-17.409 17.333v-275.88c11.594 0 17.409 0 17.409 17.329V20.89c19.417 5.652 39.829 11.882 61.027 18.642.251.08.502.166.757.242 35.036 11.2 72.157 23.839 110.355 37.674 47.846 17.346 93.523 35.163 135.078 52.53a29.7 29.7 0 0 1 14.401-10.651V-5.425c0-7.263 2.287-12.119 9.33-12.119 6.923 0 9.796 4.856 9.796 12.119v124.752c11.666 3.983 20.068 15.021 20.068 28.031 0 1.895-.2 3.747-.545 5.539 29.863 13.357 56.549 26.149 79.017 37.891h-.006c50.837 26.557 80.194 47.748 76.33 57.947-4.209 11.151-47.793 8.244-113.683-5.834v-33.047c0-5.543-2.657-15.617-13.431-21.422-12.093-6.642-24.481-13.132-37.072-19.494a29.7 29.7 0 0 1-10.678 6.426v121.19h61.181v-45.753c87.33 19.077 145.315 21.682 151.493 4.704M379.919 147.358c0 13.002 8.399 24.024 20.061 28.006v121.19h-60.751V126.787c13.648 5.899 27.284 11.956 40.808 18.189a29 29 0 0 0-.118 2.382m-96.312-13.824 34.958 162.524h-56.924l-26.924-139.834v139.834h-60.63V63.05c36.005 12.51 75.047 26.89 114.847 42.846z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 75.364 152.697)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70.762v-28.598h-178.117c-6.141 0-11.352 2.145-15.633 6.422q-6.423 6.427-6.422 22.903v45.558h46.289V0Zm98.387 120.926V91.605H70.762V37.563H26.898v40.714l-142.98-6.3q-11.877-.246-18.176 7.628-6.303 7.876-6.301 17.575v91.117h129.168V158.73H-97.18v-58.16l124.078 6.059v81.668h43.864v-67.371z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 487.627 110.991)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h186.844q13.084 0 22.777-8.484t9.695-26.414l-.242-46.528h14.059v-26.656H130.621v-35.625h70.52q10.902-.001 16.117-6.664 5.21-6.666 5.211-15.145v-52.105H176.91v46.773H-2.18v27.141h83.606v35.625H-7.512v26.656h182.965l-.242 52.102H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 555.133 14.161)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-215.922h-40.711v113.414h-19.144v-113.414h-39.02v32.473l-98.145-2.91q-12.603-.24-20.964 7.754-8.361 7.998-8.36 19.875V0h103.477v-29.082h-60.824V-158.73l84.332 2.906V0h39.504v-72.215h19.144V0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 807.067 13.912)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42.648v-51.375h25.204v-28.598H42.648v-47.254H0Zm-68.34-95.48q11.632 7.51 11.633 19.386-.001 12.115-11.633 19.508-11.637 7.39-27.387 7.391-15.51-.001-26.656-7.391-11.149-7.393-11.148-19.508 0-11.876 11.148-19.386 11.146-7.512 26.656-7.512 15.75 0 27.387 7.512m-94.027-45.559H18.176q14.052-.001 20.113-7.637 6.059-7.634 6.059-18.297v-49.675H1.453v47.253h-163.82zm134.98 86.875c5.977-6.703 8.969-14.5 8.969-23.383q0-22.055-21.934-36.23-21.93-14.178-55.375-14.176-33.2-.002-55.132 14.176-21.93 14.174-21.93 36.23c0 8.883 2.988 16.68 8.965 23.383q8.965 10.055 23.75 17.328h-32.473l-.242 26.414h52.101V10.18h52.833v-20.602h51.132l.243-26.414h-34.657q14.785-7.273 23.75-17.328",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 913.256 14.037)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-165.516v27.625H9.211c12.437 0 21.285-2.746 26.535-8.238S43.621 5.41 43.621-6.059v-137.648h14.785v-28.352h-232.644v28.352h36.105v112.445h40.473v-112.445h31.262v112.445h38.046v-112.445H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1052.635 30.383)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2631.854 1834.731h-40.469v-26.656h40.469zm-15.511-136.074c10.5 2.668 15.754 6.824 15.754 12.481q-.002 8.484-15.754 12.48-15.751 3.998-43.133 4-27.389-.002-43.141-4-15.75-3.996-15.75-12.48c0-5.657 5.25-9.813 15.75-12.481 10.5-2.66 24.883-3.996 43.141-3.996 18.254 0 32.633 1.336 43.133 3.996m-67.367 125.653h-56.465c.16-5.008.242-9.938.242-14.782v-14.054l56.223-.243zm98.386-81.668c19.547-7.434 29.325-17.934 29.325-31.504 0-13.731-9.778-24.231-29.325-31.504q-29.321-10.905-74.152-10.906-44.836 0-74.156 10.906-29.326 10.908-29.325 31.504 0 20.354 29.325 31.504c19.547 7.429 44.265 11.148 74.156 11.148 29.887 0 54.605-3.719 74.152-11.148m-98.386 139.828h42.41v-19.387h40.468v23.266h42.653v-128.922h-42.653v22.293h-40.468v-12.117h-111.961q-12.604-.001-20.965 7.996-8.36 7.998-8.359 19.875v86.996h42.41v-30.289h56.465z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 -164.01 985.201)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0q11.269 3.757 11.27 9.09-.001 5.325-11.27 9.086-11.269 3.757-28.473 3.758-17.209-.001-28.476-3.758-11.267-3.76-11.266-9.086-.001-5.333 11.266-9.09c7.511-2.508 17.004-3.758 28.476-3.758C-17.004-3.758-7.512-2.508 0 0m121.051-145.039v-28.598H-80.332q-8.97.001-15.27 6.301c-4.203 4.203-6.3 11.633-6.3 22.297v45.074h43.136v-45.316zM-11.023-67.008v-34.168h-41.684v34.168h-56.707v28.356H73.551v82.636h42.652V-116.93H73.551v15.27H10.543v21.808h63.008v12.844zM31.141 34.773Q56.101 24.111 56.102 9.09q0-15.029-24.961-25.692t-59.614-10.66q-34.418-.002-59.496 10.66-25.082 10.664-25.082 25.692 0 15.021 25.082 25.683 25.079 10.665 59.496 10.665 34.653 0 59.614-10.665",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1293.65 36.56)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-50.375h6.98q6.313 0 8.416 5.49T17.5-25.187q-.001 12.996-1.244 17.63Q14.246-.001 7.459 0Zm-14.375-61.5v72.625H9.688q13.365 0 18.332-9.455 4.105-7.747 4.105-26.455v-4.828q0-8.35-1.146-13.68-1.814-8.35-6.206-12.674Q19.138-61.5 9.113-61.5z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 433.775 147.544)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.971 31.375L-13.75 0Zm-20.498-27.25h-14.238l19.113 72.625H3.395l18.73-72.625H6.93L3.107-11.125h-19.685z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 479.372 165.18)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-13.5v72.625H5.977l18.332-50.293.191 50.293H38V0H19L.191 53.125Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 509.136 179.21)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.891L-3.414-32.59l19.305-40.035H-.383l-16.56 37.219-.192-37.219H-31.51V0h14.375v-31.08z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 558.587 141.815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0q5.741-.001 7.656 6.344 1.531 5.238 1.532 20.343-.001 15.106-1.532 20.344Q5.836 53.375 0 53.375q-5.743 0-7.656-6.344-1.532-5.238-1.532-20.344t1.674-20.896Q-5.838 0 0 0m0-10.875q-11.191 0-16.736 5.438-4.782 4.63-6.215 13.898-.861 5.436-.861 18.226t.861 18.227q1.528 9.366 6.119 13.899Q-11.285 64.25 0 64.25q11.093 0 16.736-5.437 4.78-4.634 6.215-13.797.861-5.438.861-18.329 0-12.79-.861-18.226-1.435-9.267-6.119-13.797Q11.189-10.876 0-10.875",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 589.984 174.254)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0q5.741-.001 7.656 6.344 1.531 5.238 1.532 20.343-.001 15.106-1.532 20.344Q5.836 53.375 0 53.375q-5.743 0-7.656-6.344-1.532-5.238-1.532-20.344t1.674-20.896Q-5.838 0 0 0m0-10.875q-11.191 0-16.736 5.438-4.782 4.63-6.215 13.898-.861 5.436-.861 18.226t.861 18.227q1.528 9.366 6.119 13.899Q-11.285 64.25 0 64.25q11.093 0 16.736-5.437 4.78-4.634 6.215-13.797.861-5.438.861-18.329 0-12.79-.861-18.226-1.435-9.267-6.119-13.797Q11.189-10.876 0-10.875",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 627.922 174.254)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.891L-3.414-32.59l19.305-40.035H-.383l-16.56 37.219-.192-37.219H-31.51V0h14.375v-31.08z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 669.694 141.815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.375v-51.531q0-9.36-5.061-15.198-6.206-7.147-18.33-7.146-11.552 0-17.517 5.937Q-32.501-62-32.5-51.531V0h14.375v-50.521q0-6.34 2.396-9.411T-9.207-63Q-.001-63.001 0-50.521Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 743.35 141.815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-13.5v72.625H5.977l18.332-50.293.191 50.293H38V0H19L.191 53.125Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 771.697 179.21)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1897.03 1565.321h-14.375v72.625h14.375z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 -164.01 985.201)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-17.01 72.625h15.004l10.703-52.75 12.233 52.75h14.238L16.916 0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 832.842 179.21)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-38.438v72.625H-.766V61.5h-23.296v-18H-2.58V32.375h-21.482v-21.25H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 881.95 179.21)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-20.25h6.455q3.95 0 5.879 3.525 1.54 2.822 1.541 7.155 0 5.036-1.879 7.302Q10.116 0 6.455 0Zm0-31.375V-61.5h-14.375v72.625h26.623q7.538 0 11.832-4.926 4.295-4.924 4.295-14.07 0-7.34-2.83-11.76-3.155-4.824-9.94-6.031 5.351-1.007 7.456-2.518 5.063-3.523 5.064-11.978 0-6.041.389-12.686.387-6.643 1.261-8.656H15.652q-.86 2.014-1.193 4.785a48 48 0 0 0-.334 5.694q.015 2.417 0 3.626.015 2.116 0 3.225 0 6.647-1.441 9.066-2.21 3.728-8.936 3.729z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 901.907 147.544)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0q0-12.588-7.926-17.521-5.636-3.526-16.138-3.526-12.224 0-16.903 7.055Q-44.5-8.654-44.5 2.635h14.375q0-6.657 1.053-8.975 1.721-3.832 7.176-3.832 3.633 0 5.453 2.215 1.817 2.216 1.818 6.043-.001 5.235-7.25 10.019a1207 1207 0 0 0-14.213 9.518q-7.537 6.744-7.537 16.012 0 9.465 4.771 14.502 5.629 5.941 17.94 5.941 10.591 0 15.314-5.191t4.725-16.678h-14q-.001 5.042-1.145 7.564-1.529 3.43-5.537 3.43-7.444-.001-7.443-7.754 0-5.44 7.441-10.172 13.641-8.66 14.022-8.963Q-.001 9.769 0 0",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 951.878 169.017)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2207.229 1565.321h-14.375v72.625h14.375z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 -164.01 985.201)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46.375v-12.125h-16v-60.5H16v60.5H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 983.818 141.815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v25.146l-18 47.479h15.713L7.996 41.947l11.029 30.678h14.77l-19.42-47.479V0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1025.626 179.21)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.625v29.125H31V-43.5H16.625v32.375H0V-43.5h-14.375v72.625H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1099.608 156.812)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0q5.741-.001 7.656 6.344 1.531 5.238 1.532 20.343-.001 15.106-1.532 20.344Q5.836 53.375 0 53.375q-5.743 0-7.656-6.344-1.532-5.238-1.532-20.344t1.674-20.896Q-5.838 0 0 0m0-10.875q-11.191 0-16.736 5.438-4.782 4.63-6.215 13.898-.861 5.436-.861 18.226t.861 18.227q1.528 9.366 6.119 13.899Q-11.285 64.25 0 64.25q11.093 0 16.736-5.437 4.78-4.634 6.215-13.797.861-5.438.861-18.329 0-12.79-.861-18.226-1.435-9.267-6.119-13.797Q11.189-10.876 0-10.875",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1141.826 174.254)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0q0-12.588-7.926-17.521-5.636-3.526-16.138-3.526-12.224 0-16.903 7.055Q-44.5-8.654-44.5 2.635h14.375q0-6.657 1.053-8.975 1.721-3.832 7.176-3.832 3.633 0 5.453 2.215 1.817 2.216 1.818 6.043-.001 5.235-7.25 10.019a1207 1207 0 0 0-14.213 9.518q-7.537 6.744-7.537 16.012 0 9.465 4.771 14.502 5.629 5.941 17.94 5.941 10.591 0 15.314-5.191t4.725-16.678h-14q-.001 5.042-1.145 7.564-1.529 3.43-5.537 3.43-7.444-.001-7.443-7.754 0-5.44 7.441-10.172 13.641-8.66 14.022-8.963Q-.001 9.769 0 0",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1189.836 169.017)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-20.75h8.072q3.17 0 5.237 2.92 2.066 2.92 2.066 6.851-.001 5.137-1.537 7.756Q11.915 0 7.303 0Zm-14.375-61.5v72.625h26.014q9.561 0 14.154-5.826Q30-.127 30-10.576q0-8.44-3.258-13.664-4.792-7.635-16.008-7.635H0V-61.5Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1210.522 147.544)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2737.795 1565.321h-14.375v72.625h14.375z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 -164.01 985.201)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46.375v-12.125h-16v-60.5H16v60.5H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1257.008 141.815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.971 31.375L-13.75 0Zm-20.498-27.25h-14.238l19.113 72.625H3.395l18.73-72.625H6.93L3.107-11.125h-19.685z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1307.506 165.18)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.685132
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-36.02v72.625h14.375v-60.5H0Z",
    style: {
      fill: "#1d4e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.685132
    },
    transform: "matrix(.5149 0 0 -.5149 1348.864 179.21)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDkUlogo);
export default __webpack_public_path__ + "static/media/DKUlogo.7f8736ca4b6ea521c852a4268d11e30b.svg";
export { ForwardRef as ReactComponent };